import { ReactComponent as IconArrowTop } from 'asserts/icons/ic_arrow_top.svg';
import { color } from 'asserts/styles/colors';

import styled from 'styled-components';

interface ScrollToButtonProps {
  onClick: () => void;
}

const ScrollToTopButton = ({ onClick }: ScrollToButtonProps) => {
  return (
    <Wrapper onClick={onClick}>
      <Icon>
        <IconArrowTop />
      </Icon>
    </Wrapper>
  );
};

export default ScrollToTopButton;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 24px;
  right: 24px;
  @media (min-width: 1920px) {
    right: calc(((100% - 1920px) / 2) + 24px);
  }

  gap: 16px;
  width: 48px;
  height: 48px;
  border-radius: 107px;
  border: 1px solid ${color.gray200};
  background: ${color.white};
  box-shadow: 0px 4px 8px 0px ${color.opacityBlack01};
  cursor: pointer;
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
